import styled from "styled-components";

export const Bloco = styled.section`
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 16px;
  display: grid;
  gap: 18px;
  margin: 28px 0;
  padding: 24px;

  @media (max-width: 640px) {
    border-radius: 12px;
    padding: 18px 14px;
  }
`;

export const Cabecalho = styled.header`
  display: grid;
  gap: 6px;

  h3 {
    color: #202124;
    font-family: Roboto, system-ui, sans-serif;
    font-size: 20px;
    margin: 0;
  }

  p {
    color: #5f6368;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
    max-width: 720px;
  }
`;

export const Grafico = styled.div`
  height: 280px;
  position: relative;

  @media (max-width: 640px) {
    height: 230px;
  }
`;

export const ListaDeTermos = styled.ol`
  display: grid;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const Linha = styled.li`
  align-items: center;
  border-bottom: 1px solid #eef1f5;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) auto auto;
  padding: 11px 2px;

  .termo {
    color: #202124;
    font-size: 14px;
    overflow-wrap: anywhere;
  }

  .grupo {
    color: #5f6368;
    display: block;
    font-size: 12px;
    margin-top: 2px;
  }

  strong {
    color: #1a73e8;
    font-size: 15px;
    font-variant-numeric: tabular-nums;
    text-align: right;
  }
`;

export const Selo = styled.span<{ $novo?: boolean }>`
  background: ${({ $novo }) => ($novo ? "#e8f0fe" : "#e6f4ea")};
  border-radius: 999px;
  color: ${({ $novo }) => ($novo ? "#1967d2" : "#137333")};
  font-size: 12px;
  font-weight: 700;
  min-width: 52px;
  padding: 3px 9px;
  text-align: center;
`;

export const SemSelo = styled.span`
  min-width: 52px;
`;

export const Nota = styled.p`
  color: #5f6368;
  font-size: 12.5px;
  line-height: 1.5;
  margin: 0;
`;

export const Aviso = styled.p`
  background: #f8fafc;
  border-radius: 10px;
  color: #5f6368;
  font-size: 14px;
  margin: 0;
  padding: 16px;
`;
